import { initializeApp } from "firebase/app";
import { getStorage, uploadBytesResumable, ref, getDownloadURL } from "firebase/storage";
import { useState } from 'react';
import {
    GoogleAuthProvider,
    getAuth,
    signInWithPopup,
    signInWithEmailAndPassword,
    createUserWithEmailAndPassword,
    sendPasswordResetEmail,
    signOut,
} from "firebase/auth";
import {
    getFirestore,
    query,
    getDocs,
    collection,
    where,
    addDoc,
    doc,
    setDoc,
} from "firebase/firestore";
// For Firebase JS SDK v7.20.0 and later, measurementId is optional

const firebaseConfig = {
    apiKey: "AIzaSyCLxcyiWuvHasCbzxAo7FZPnraOVV2XF54",
    authDomain: "alumini-reconnect.firebaseapp.com",
    databaseURL: "https://alumini-reconnect-default-rtdb.firebaseio.com",
    projectId: "alumini-reconnect",
    storageBucket: "alumini-reconnect.appspot.com",
    messagingSenderId: "844337343359",
    appId: "1:844337343359:web:59ed7f21030610b1f1884a",
    measurementId: "G-EELZCDRPXS"
};
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);
const registerWithEmailAndPassword = async(name, email, password) => {
    try {
        const res = await createUserWithEmailAndPassword(auth, email, password);
        const user = await addDoc(collection(db, "Users"), {
            FirstName: name,
            EmailId: email,
        });
        sessionStorage.setItem("userid", user.id);
        console.log(user.id)
        return "success";
    } catch (err) {
        return err.message;
    }
};
const uploadPersonalInfo = async(salutation, first, last, gender, dob, image) => {
    let data = {
        FirstName: first,
        LastName: last,
        DOB: dob,
        Salutation: salutation,
        Gender: gender
    }
    let setwithMerge = setDoc(doc(db, "Users", sessionStorage.getItem("userid")), data, { merge: true });
    const storageRef = ref(storage, `Images/${image.name}`);
    if (image == null) return;
    const uploadTask = uploadBytesResumable(storageRef, image);
    uploadTask.on('state_changed', () => {
        // Handle successful uploads on complete
        // For instance, get the download URL: https://firebasestorage.googleapis.com/...
        getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
            setDoc(doc(db, "Users", sessionStorage.getItem("userid")), { ProfileImage: downloadURL }, { merge: true });
        });
    });
};

const uploadEducationalInfo = async(university, degree, timefrom, timeto) => {
    let data = {
        University: university,
        Degree: degree,
        Timefrom: timefrom,
        Timeto: timeto
    }
    let setwithMerge = setDoc(doc(db, "Users", sessionStorage.getItem("userid")), data, { merge: true });
};
const uploadContactInformation = async(contact, linkedin, country, state, address, pincode) => {
    let data = {
        MobileNumber: contact,
        Links: { linkedin },
        PermanentAddress: address,
        Country: country,
        State: state,
        Pincode: pincode
    }
    let setwithMerge = setDoc(doc(db, "Users", sessionStorage.getItem("userid")), data, { merge: true });
};
const uploadWorkInformation = async(headline, position, company, designation, workfrom, workto, location) => {
    let data = {
        Headline: headline,
        Position: position,
        Company: company,
        Designation: designation,
        Workfrom: workfrom,
        Workto: workto,
        Location: location
    }
    let setwithMerge = setDoc(doc(db, "Users", sessionStorage.getItem("userid")), data, { merge: true });
};

export default registerWithEmailAndPassword;
export { uploadPersonalInfo, uploadEducationalInfo, uploadContactInformation, uploadWorkInformation };